<template>
  <div style="text-align: center;">
    <el-upload
      ref="uploader"
      action=""
      accept=".CSV"
      drag
      :auto-upload="false"
      :on-change="onFileChange"
      :on-remove="onFileRemove"
      :limit="1"
      :on-exceed="onExceed"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <div
        slot="tip"
        class="el-upload__tip"
      >
        Only Accepts .CSV file
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  data () {
    return {
      files: []
    }
  },
  methods: {
    onFileChange (file, fileList) {
      this.$emit('selected', file)
    },
    onFileRemove (file, fileList) {
      this.$emit('selected', null)
    },
    onExceed (files, fileList) {
      this.$message({ message: 'Only 1 file can be uploaded at a time', type: 'error' })
    }
  }
}
</script>

<style>

</style>
